import { useState, useMemo } from 'react'
import { InsightContentSettingType } from 'components/insightContent/types'
import { InsightData } from 'schemas/action/InsightDataSchema'
import { generateDayHoursStrategy } from 'utils/insightModal/strategy/searchFilterComposing'
import { generateDayHoursStrategy as generateDayHoursStrategyForWidgetSetting } from 'utils/insightModal/strategy/widgetSettingComposing'

import {
  convertToInsightContentSetting,
  addSelectionFilterToWidgetSetting
} from './share/InsightModal/utils'
import { DayAndHourWidgetsType } from './types'

const useSelectedInsights = (widgetSetting: DayAndHourWidgetsType) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [selectedInsights, setSelectedInsights] = useState<InsightData[]>([])
  // * all viewOption uusing same strategy
  const searchFilterComposingStrategy = generateDayHoursStrategy()
  // * all viewOption uusing same strategy
  const widgetSettingComposingStrategy = generateDayHoursStrategyForWidgetSetting()

  const detailSetting = useMemo<InsightContentSettingType | undefined>(() => {
    if (isModalOpen && selectedInsights.length > 0) {
      return convertToInsightContentSetting(
        widgetSetting,
        searchFilterComposingStrategy,
        selectedInsights
      )
    }
    return undefined
  }, [isModalOpen, widgetSetting, searchFilterComposingStrategy, selectedInsights])

  const widgetSettingWithSelection = useMemo<any>(() => {
    if (isModalOpen && selectedInsights.length > 0) {
      return addSelectionFilterToWidgetSetting(
        widgetSetting,
        widgetSettingComposingStrategy,
        selectedInsights
      )
    }
    return undefined
  }, [isModalOpen, widgetSetting, widgetSettingComposingStrategy, selectedInsights])

  // * TODO: change to InsightsSelectFunc type
  const handleInsightsSelect = (insights: InsightData[]) => {
    setSelectedInsights(insights)
    setIsModalOpen(true)
  }

  return {
    selectedInsights,
    handleInsightsSelect,
    detailSetting,
    widgetSettingWithSelection,
    isModalOpen,
    setIsModalOpen
  }
}

export default useSelectedInsights
